(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/outcome/assets/javascripts/outcome.js') >= 0) return;  svs.modules.push('/components/lb-ui/outcome/assets/javascripts/outcome.js');
"use strict";


const clx = svs.components.lbUtils.clx;
const Outcome = _ref => {
  let ariaLabel = _ref.ariaLabel,
    branding = _ref.branding,
    className = _ref.className,
    dataTestId = _ref.dataTestId,
    hasUSign = _ref.hasUSign,
    _ref$isBestBetRow = _ref.isBestBetRow,
    isBestBetRow = _ref$isBestBetRow === void 0 ? false : _ref$isBestBetRow,
    _ref$isBestBetOutcome = _ref.isBestBetOutcome,
    isBestBetOutcome = _ref$isBestBetOutcome === void 0 ? false : _ref$isBestBetOutcome,
    isDisabled = _ref.isDisabled,
    _ref$isResult = _ref.isResult,
    isResult = _ref$isResult === void 0 ? false : _ref$isResult,
    isSelected = _ref.isSelected,
    sign = _ref.sign,
    _ref$shouldShowResult = _ref.shouldShowResult,
    shouldShowResult = _ref$shouldShowResult === void 0 ? false : _ref$shouldShowResult;
  const isResultSelected = isResult && isSelected;
  const isResultNotSelected = isResult && !isSelected;
  const isCorrectResultSelected = isBestBetRow ? isResultSelected && isBestBetOutcome : isResultSelected;
  const isCorrectResultNotSelected = isBestBetRow ? isResultNotSelected && isBestBetOutcome : isResultNotSelected;
  const outcomeClassNames = clx('pg_outcome', className, {
    'pg_outcome--disabled': isDisabled,
    'pg_outcome--selected': isSelected,
    'pg_outcome--correct': shouldShowResult && isResult,
    'pg_outcome--best-bet': isBestBetRow && isBestBetOutcome,
    'pg_outcome--correct-selected': shouldShowResult && isCorrectResultSelected,
    'pg_outcome--correct-not-selected': shouldShowResult && isCorrectResultNotSelected,
    ["pg_outcome--".concat(branding)]: branding
  });
  return React.createElement("span", {
    "aria-label": ariaLabel,
    className: outcomeClassNames,
    "data-testid": dataTestId
  }, React.createElement("span", {
    className: "pg_outcome__sign"
  }, sign), hasUSign && React.createElement("span", {
    className: "pg_outcome--system"
  }, "U"));
};
setGlobal('svs.components.lbUi.outcome.Outcome', Outcome);

 })(window);